// Default range-slider precision. Individual facets can override with
// `precision: 2` or `precision: { imperial: 3, metric: 1 }`.
export const numericFilterPrecision = {
  imperial: 3,
  metric: 1,
};

const basicFacets = {
  "main-category": {
    attribute: "main_category",
    label: "Refine by Category",
    label_column: "Category",
    type: "refinementList",
    sortable: true,
  },
  type: {
    attribute: "type",
    label: "Type",
    type: "refinementList",
    sortable: true,
    buildFromAttributes: [
      "taxonomies.pa_balloon-type",
      "taxonomies.pa_balloons-type",
      "taxonomies.pa_batteries-type",
      "taxonomies.pa_bobbin-type",
      "taxonomies.pa_braid-type",
      "taxonomies.pa_braid-wire-type",
      "taxonomies.pa_braided-structure-type",
      "taxonomies.pa_braided-structures-type",
      "taxonomies.pa_cases-trays-type",
      "taxonomies.pa_catheter-handles-type",
      "taxonomies.pa_catheter-type",
      "taxonomies.pa_coatings-type",
      "taxonomies.pa_component-type",
      "taxonomies.pa_connector-type",
      "taxonomies.pa_connectors-fittings-type",
      "taxonomies.pa_connectors-fittings-types",
      "taxonomies.pa_core-type",
      "taxonomies.pa_cure-type",
      "taxonomies.pa_dis-type",
      "taxonomies.pa_electrode-type",
      "taxonomies.pa_element-type",
      "taxonomies.pa_feeder-type",
      "taxonomies.pa_filters-valves-type",
      "taxonomies.pa_guidewire-accessories-types",
      "taxonomies.pa_guidewire-type",
      "taxonomies.pa_guidewire-types",
      "taxonomies.pa_handle-type",
      "taxonomies.pa_hub-type",
      "taxonomies.pa_lab-kit-type",
      "taxonomies.pa_lead-body-cable-type",
      "taxonomies.pa_luer-type",
      "taxonomies.pa_mandrel-type",
      "taxonomies.pa_mandrels-type",
      "taxonomies.pa_membrane-type",
      "taxonomies.pa_motor-type",
      "taxonomies.pa_needles-scalpel-type",
      "taxonomies.pa_needles-scalpels-type",
      "taxonomies.pa_nozzle-type",
      "taxonomies.pa_packaging-type",
      "taxonomies.pa_point-type",
      "taxonomies.pa_polymer-tubing-type",
      "taxonomies.pa_punch-tool-type",
      "taxonomies.pa_raw-materials-type",
      "taxonomies.pa_seal-type",
      "taxonomies.pa_sensor-type",
      "taxonomies.pa_sensors-type",
      "taxonomies.pa_sharps-type",
      "taxonomies.pa_spool-type",
      "taxonomies.pa_spring-type",
      "taxonomies.pa_stopcock-type",
      "taxonomies.pa_syringes-type",
      "taxonomies.pa_textiles-type",
      "taxonomies.pa_tools-type",
      "taxonomies.pa_tubing-type",
      "taxonomies.pa_wire-type",
    ],
  },
  availability: {
    attribute: "availability",
    label: "Availability",
    type: "refinementList",
    sortable: false,
    tooltip:
      "In Stock: Ships in 1-2 business days\u000AQuick Turn: Ships in 4 weeks or less",
  },
  description: {
    attribute: "name",
    label: "Description",
    type: "refinementList",
    sortable: true,
  },
  "item-number": {
    attribute: "item_number",
    label: "Item Number",
    type: "refinementList",
    sortable: true,
  },
  price: {
    attribute: "price",
    label: "Price",
    type: "rangeSlider",
    sortable: true,
  },
  "width-in": {
    attribute: "taxonomies.pa_width-in",
    label: "Width (in)",
    type: "rangeSlider",
    sortable: true,
    units: "in",
    precision: { imperial: 3, metric: 1 },
  },
  "thickness-in": {
    attribute: "taxonomies.pa_thickness-in",
    label: "Thickness (in)",
    type: "rangeSlider",
    sortable: true,
    units: "in",
    precision: { imperial: 4, metric: 2 },
  },
  material: {
    attribute: "taxonomies.pa_material",
    label: "Material",
    type: "refinementList",
    sortable: true,
  },
  "material-grade": {
    attribute: "taxonomies.pa_material-grade",
    label: "Material Grade",
    type: "refinementList",
    sortable: true,
  },
  durometer: {
    attribute: "taxonomies.pa_durometer",
    label: "Durometer",
    type: "refinementList",
    sortable: true,
  },
  "tubing-id-in": {
    attribute: "taxonomies.pa_tubing-id-in",
    label: "ID (in)",
    type: "rangeSlider",
    units: "in",
    precision: { metric: 3, imperial: 2 },
    sortable: true,
  },
  "tubing-od-in": {
    attribute: "taxonomies.pa_tubing-od-in",
    label: "OD (in)",
    type: "rangeSlider",
    units: "in",
    precision: { metric: 2, imperial: 4 },
    sortable: true,
  },
  "wall-thickness-in": {
    attribute: "taxonomies.pa_wall-thickness-in",
    label: "Wall Thickness (in)",
    label_column: "Wall (in)",
    type: "rangeSlider",
    units: "in",
    sortable: true,
  },
  "length-in": {
    attribute: "taxonomies.pa_length-in",
    label: "Length (in)",
    type: "rangeSlider",
    units: "in",
    sortable: true,
  },
  "tubing-type": {
    attribute: "taxonomies.pa_tubing-type",
    label: "Type",
    type: "refinementList",
    sortable: true,
  },
  "min-exp-id-in": {
    attribute: "taxonomies.pa_min-exp-id-in",
    label: "Min exp ID (in)",
    type: "rangeSlider",
    sortable: true,
    units: "in",
    precision: { imperial: 4, metric: 2 },
  },
  "max-recovered-id-in": {
    attribute: "taxonomies.pa_max-recovered-id-in",
    label: "Max recovered ID (in)",
    type: "rangeSlider",
    sortable: true,
    units: "in",
    precision: { imperial: 4, metric: 2 },
  },
  "hst-shrink-ratio": {
    attribute: "taxonomies.pa_hst-shrink-ratio",
    label: "HST Shrink Ratio",
    type: "refinementList",
    sortable: true,
  },
  "mandrels-type": {
    attribute: "taxonomies.pa_mandrels-type",
    label: "Type",
    type: "refinementList",
    sortable: false,
  },
  "surface-finish": {
    attribute: "taxonomies.pa_surface-finish",
    label: "Surface Finish",
    type: "refinementList",
    sortable: true,
  },
  "balloons-diameter-mm": {
    attribute: "taxonomies.pa_balloons-diameter-mm",
    label: "Diameter (mm)",
    type: "rangeSlider",
    units: "mm",
    sortable: true,
    precision: { imperial: 4, metric: 2 },
  },
  "balloons-working-length": {
    attribute: "taxonomies.pa_balloons-working-length",
    label: "Working Length (mm)",
    label_column: "Length (mm)",
    type: "rangeSlider",
    sortable: true,
    units: "mm",
    precision: { imperial: 2, metric: 1 },
  },
  shape: {
    attribute: "taxonomies.pa_shape",
    label: "Shape",
    type: "refinementList",
    sortable: true,
  },
  "balloons-type": {
    attribute: "taxonomies.pa_balloons-type",
    label: "Type",
    type: "refinementList",
    sortable: false,
  },
  "catheter-type": {
    attribute: "taxonomies.pa_catheter-type",
    label: "Type",
    type: "refinementList",
    sortable: false,
  },
  "catheter-handles-type": {
    attribute: "taxonomies.pa_catheter-handles-type",
    label: "Type",
    type: "refinementList",
    sortable: false,
  },
  "coatings-type": {
    attribute: "taxonomies.pa_coatings-type",
    label: "Type",
    type: "refinementList",
    sortable: false,
  },
  "external-tube-od-fr": {
    attribute: "taxonomies.pa_external-tube-od-fr",
    label: "External Tube OD (Fr)",
    type: "refinementList",
    sortable: true,
  },
  "internal-tube-od-fr": {
    attribute: "taxonomies.pa_internal-tube-od-fr",
    label: "Internal Tube OD (Fr)",
    type: "refinementList",
    sortable: true,
  },
  "external-stroke-mm": {
    attribute: "taxonomies.pa_external-stroke-mm",
    label: "External Stroke (mm)",
    type: "refinementList",
    sortable: true,
  },
  "internal-stroke-mm": {
    attribute: "taxonomies.pa_internal-stroke-mm",
    label: "Internal Stroke (mm)",
    type: "refinementList",
    sortable: true,
  },
  "sharps-type": {
    attribute: "taxonomies.pa_sharps-type",
    label: "Type",
    type: "refinementList",
    sortable: false,
  },
  "point-type": {
    attribute: "taxonomies.pa_point-type",
    label: "Point Type",
    type: "refinementList",
    sortable: false,
  },
  color: {
    attribute: "taxonomies.pa_color",
    label: "Color",
    type: "refinementList",
    sortable: true,
  },
  "textiles-type": {
    attribute: "taxonomies.pa_textiles-type",
    label: "Type",
    type: "refinementList",
    sortable: false,
  },
  "connectors-fittings-type": {
    attribute: "taxonomies.pa_connectors-fittings-type",
    label: "Type",
    type: "refinementList",
    sortable: false,
  },
  "tools-type": {
    attribute: "taxonomies.pa_tools-type",
    label: "Type",
    type: "refinementList",
    sortable: false,
  },
  "electrode-type": {
    attribute: "taxonomies.pa_electrode-type",
    label: "Type",
    type: "refinementList",
    sortable: false,
  },
  "id-mm": {
    attribute: "taxonomies.pa_id-mm",
    label: "ID (mm)",
    type: "rangeSlider",
    sortable: true,
    units: "mm",
    precision: { imperial: 4, metric: 2 },
  },
  "length-mm": {
    attribute: "taxonomies.pa_length-mm",
    label: "Length (mm)",
    type: "rangeSlider",
    sortable: true,
    units: "mm",
    precision: { imperial: 4, metric: 2 },
  },
  "length-ft": {
    attribute: "taxonomies.pa_length-ft",
    label: "Length (ft)",
    type: "rangeSlider",
    sortable: true,
    units: "ft",
  },
  "membrane-type": {
    attribute: "taxonomies.pa_membrane-type",
    label: "Type",
    type: "refinementList",
    sortable: false,
  },
  covering: {
    attribute: "taxonomies.pa_covering",
    label: "Covering",
    type: "refinementList",
    sortable: false,
  },
  awg: {
    attribute: "taxonomies.pa_awg",
    label: "AWG",
    type: "refinementList",
    sortable: true,
  },
  "wire-type": {
    attribute: "taxonomies.pa_wire-type",
    label: "Type",
    type: "refinementList",
    sortable: false,
  },
  "wire-size": {
    attribute: "taxonomies.pa_wire-size",
    label: "Wire Size",
    type: "refinementList",
    sortable: true,
  },
  ppi: {
    attribute: "taxonomies.pa_ppi",
    label: "PPI",
    type: "refinementList",
    sortable: true,
  },
  construction: {
    attribute: "taxonomies.pa_construction",
    label: "Construction",
    type: "refinementList",
    sortable: false,
  },
  seller: {
    attribute: "seller",
    label: "Seller",
    type: "refinementList",
    sortable: true,
  },
  "pull-ring-material": {
    attribute: "taxonomies.pa_pull-ring-material",
    label: "Pull Ring Material",
    type: "refinementList",
    sortable: true,
  },
  "pull-ring-od-in": {
    attribute: "taxonomies.pa_pull-ring-od-in",
    label: "Pull Ring OD (in)",
    type: "rangeSlider",
    sortable: true,
    units: "in",
    precision: { imperial: 4, metric: 2 },
  },
  "pull-ring-id-in": {
    attribute: "taxonomies.pa_pull-ring-id-in",
    label: "Pull Ring ID (in)",
    type: "rangeSlider",
    sortable: true,
    units: "in",
    precision: { imperial: 4, metric: 2 },
  },
  "pull-ring-wires": {
    attribute: "taxonomies.pa_pull-wires",
    label: "# Pull Wires",
    type: "refinementList",
    sortable: true,
  },
  "pull-ring-wire-material": {
    attribute: "taxonomies.pa_pull-wire-material",
    label: "Pull Wire Material",
    type: "refinementList",
    sortable: true,
  },
  "pull-ring-wire-od-in": {
    attribute: "taxonomies.pa_pull-wire-od-in",
    label: "Pull Wire OD (in)",
    type: "rangeSlider",
    sortable: true,
    units: "in",
    precision: { imperial: 3, metric: 1 },
  },
  "pull-ring-wire-length-in": {
    attribute: "taxonomies.pa_pull-wire-length-in",
    label: "Pull Wire Length (in)",
    type: "rangeSlider",
    sortable: true,
    units: "in",
    precision: 0,
  },
  "raw-materials-type": {
    attribute: "taxonomies.pa_raw-materials-type",
    label: "Type",
    type: "refinementList",
    sortable: false,
  },
  "french-size": {
    attribute: "taxonomies.pa_french-size",
    label: "French Size",
    type: "rangeSlider",
    sortable: true,
  },
  "gauge-size": {
    attribute: "taxonomies.pa_gauge-size",
    label: "Gauge Size",
    type: "refinementList",
    sortable: true,
  },
  "pitch-in": {
    attribute: "taxonomies.pa_pitch-in",
    label: "Pitch (in)",
    type: "rangeSlider",
    sortable: true,
    units: "in",
  },
  cpr: {
    attribute: "taxonomies.pa_cpr",
    label: "CPR",
    type: "refinementList",
    sortable: true,
  },
  "guidewire-type": {
    attribute: "taxonomies.pa_guidewire-type",
    label: "Type",
    type: "refinementList",
    sortable: false,
  },
  "guidewire-types": {
    attribute: "taxonomies.pa_guidewire-types",
    label: "Type",
    type: "refinementList",
    sortable: false,
  },
  "dis-type": {
    attribute: "taxonomies.pa_dis-type",
    label: "Type",
    type: "refinementList",
    sortable: false,
  },
  "filters-valves-type": {
    attribute: "taxonomies.pa_filters-valves-type",
    label: "Type",
    type: "refinementList",
    sortable: false,
  },
  "sensor-type": {
    attribute: "taxonomies.pa_sensor-type",
    label: "Type",
    type: "refinementList",
    sortable: false,
  },
  "spring-type": {
    attribute: "taxonomies.pa_spring-type",
    label: "Type",
    type: "refinementList",
    sortable: false,
  },
  "vent-type": {
    attribute: "taxonomies.pa_vent-type",
    label: "Type",
    type: "refinementList",
    sortable: false,
  },
  "vent-rating": {
    attribute: "taxonomies.pa_vent-rating",
    label: "Vent Rating",
    type: "refinementList",
    sortable: false,
  },
  "cases-trays-type": {
    attribute: "taxonomies.pa_cases-trays-type",
    label: "Type",
    type: "refinementList",
    sortable: false,
  },
  packaging: {
    attribute: "taxonomies.pa_packaging",
    label: "Packaging",
    type: "refinementList",
    sortable: true,
  },
  "packaging-type": {
    attribute: "taxonomies.pa_packaging-type",
    label: "Type",
    type: "refinementList",
    sortable: false,
  },
  "syringes-type": {
    attribute: "taxonomies.pa_syringes-type",
    label: "Type",
    type: "refinementList",
    sortable: false,
  },
  volume: {
    attribute: "taxonomies.pa_volume-ml",
    label: "Volume (mL)",
    type: "rangeSlider",
    sortable: true,
    precision: 2,
  },
  "needles-scalpels-type": {
    attribute: "taxonomies.pa_needles-scalpels-type",
    label: "Type",
    type: "refinementList",
    sortable: false,
  },
  "bobbin-type": {
    attribute: "taxonomies.pa_bobbin-type",
    label: "Bobbin Type",
    type: "refinementList",
    sortable: false,
  },
  "tensile-tange-ksi": {
    attribute: "taxonomies.pa_tensile-range-ksi",
    label: "Tensile Range (ksi)",
    type: "refinementList",
    sortable: true,
  },
  condition: {
    attribute: "taxonomies.pa_condition",
    label: "Condition",
    type: "refinementList",
    sortable: false,
  },
  size: {
    attribute: "taxonomies.pa_size",
    label: "Size",
    type: "refinementList",
    sortable: true,
  },
  "number-of-teeth": {
    attribute: "taxonomies.pa_number-of-teeth",
    label: "Number of Teeth",
    type: "refinementList",
    sortable: true,
  },
  "pitch-diameter-in": {
    attribute: "taxonomies.pa_pitch-diameter-in",
    label: "Pitch Diameter (in)",
    type: "rangeSlider",
    sortable: true,
    units: "in",
  },
  "lead-time": {
    attribute: "taxonomies.pa_lead-time",
    label: "Lead Time",
    type: "refinementList",
    sortable: true,
  },
  "proximal-neck-id-in": {
    attribute: "taxonomies.pa_proximal-neck-id-in",
    label: "Proximal Neck ID (in)",
    type: "rangeSlider",
    sortable: true,
    units: "in",
    precision: { imperial: 4, metric: 2 },
  },
  "distal-neck-id-in": {
    attribute: "taxonomies.pa_distal-neck-id-in",
    label: "Distal Neck ID (in)",
    type: "rangeSlider",
    sortable: true,
    units: "in",
    precision: { imperial: 4, metric: 2 },
  },
  gauge: {
    attribute: "taxonomies.pa_gauge",
    label: "Gauge",
    type: "rangeSlider",
    sortable: true,
    precision: 0,
  },
  "gauge-wall": {
    attribute: "taxonomies.pa_gauge-wall",
    label: "Gauge Wall",
    type: "refinementList",
    sortable: true,
  },
  "case-material": {
    attribute: "taxonomies.pa_case-material",
    label: "Case Material",
    type: "refinementList",
    sortable: false,
  },
  "dash-number": {
    attribute: "taxonomies.pa_dash-number",
    label: "Dash Number",
    type: "refinementList",
    sortable: true,
  },
  "fda-compliant": {
    attribute: "taxonomies.pa_fda-compliant",
    label: "FDA Compliant",
    type: "refinementList",
    sortable: false,
  },
  "3a-compliant": {
    attribute: "taxonomies.pa_3a-compliant",
    label: "3A Compliant",
    type: "refinementList",
    sortable: false,
  },
  "usp-class-vi": {
    attribute: "taxonomies.pa_usp-class-vi",
    label: "USP Class VI",
    type: "refinementList",
    sortable: false,
  },
  "reach-rohs-compliant": {
    attribute: "taxonomies.pa_reach-rohs-compliant",
    label: "REACH/ROHS Compliant",
    type: "refinementList",
    sortable: false,
  },
  "metal-detectable": {
    attribute: "taxonomies.pa_metal-detectable",
    label: "Metal Detectable",
    type: "refinementList",
    sortable: false,
  },
  cleanroom: {
    attribute: "taxonomies.pa_cleanroom",
    label: "Cleanroom",
    type: "refinementList",
    sortable: false,
  },
  "compatible-shaft-fr": {
    attribute: "taxonomies.pa_compatible-shaft-fr",
    label: "Compatible Shaft (Fr)",
    type: "rangeSlider",
    sortable: false,
    precision: 0,
  },
  "shaft-hub-id-in": {
    attribute: "taxonomies.pa_shaft-hub-id-in",
    label: "Shaft Hub ID (in)",
    type: "rangeSlider",
    sortable: true,
    units: "in",
    precision: { imperial: 3, metric: 1 },
  },
  "handle-length-in": {
    attribute: "taxonomies.pa_handle-length-in",
    label: "Handle Length (in)",
    type: "rangeSlider",
    sortable: true,
    units: "in",
    precision: 0,
  },
};

// Create converted facets.
Object.keys(basicFacets).forEach((key) => {
  const { units, attribute, label, label_column } = basicFacets[key];
  if (units) {
    const newUnits =
      units === "mm"
        ? "in"
        : units === "in"
          ? "mm"
          : units === "cm"
            ? "ft"
            : units === "ft"
              ? "cm"
              : units;
    const newKey = key.replace(new RegExp(`-${units}\$`), "") + "-" + newUnits;
    // console.log(key, newKey);
  }
});

export const facets = basicFacets;

export const filterAssignments = {
  // This set of facets and columns displayed by default if no assignment found for the category.
  DEFAULT: {
    displayFacets: [],
    displayHits: [
      { key: "main-category", orderColumns: 3, adminOnly: false },
      { key: "description", orderColumns: 4, adminOnly: false },
    ],
  },
  SERP: {
    displayFacets: [
      { key: "item-number", orderFacets: 11, adminOnly: true },
      { key: "main-category", orderFacets: 10, adminOnly: false, isOpen: true },
      { key: "lead-time", orderFacets: 12, adminOnly: false },
      { key: "seller", orderFacets: 92, adminOnly: false },
    ],
    displayHits: [
      { key: "item-number", orderColumns: 1, adminOnly: false },
      { key: "name", orderColumns: 2, adminOnly: false },
      { key: "main-category", orderColumns: 10, adminOnly: false },
      { key: "description", orderColumns: 11, adminOnly: false },
      { key: "seller", orderColumns: 93, adminOnly: false },
      { key: "packaging", orderColumns: 94, adminOnly: false },
      { key: "price", orderColumns: 95, adminOnly: false },
    ],
  },
  SELLER: {
    displayFacets: [
      { key: "item-number", hide: true },
      { key: "main-category", orderFacets: 10, adminOnly: false, isOpen: true },
      { key: "lead-time", orderFacets: 12, adminOnly: false },
    ],
    displayHits: [
      { key: "item-number", orderColumns: 1, adminOnly: false },
      { key: "name", orderColumns: 2, adminOnly: false },
      { key: "main-category", orderColumns: 10, adminOnly: false },
      { key: "description", orderColumns: 11, adminOnly: false },
      { key: "price", orderColumns: 95, adminOnly: false },
    ],
  },
  RECENT: {
    displayFacets: [
      { key: "item-number", hide: true },
      { key: "main-category", orderFacets: 10, adminOnly: false, isOpen: true },
      { key: "lead-time", orderFacets: 12, adminOnly: false },
      { key: "seller", orderFacets: 92, adminOnly: false },
    ],
  },
  // This set of facets and columns displayed for every category.
  EVERY: {
    displayFacets: [
      { key: "item-number", orderFacets: 11, adminOnly: true },
      { key: "availability", orderFacets: 98, adminOnly: false },
      { key: "lead-time", orderFacets: 99, adminOnly: false },
      { key: "seller", orderFacets: 92, adminOnly: false },
    ],
    displayHits: [
      { key: "item-number", orderColumns: 1, adminOnly: false },
      { key: "name", orderColumns: 2, adminOnly: false },
      { key: "seller", orderColumns: 93, adminOnly: false },
      { key: "packaging", orderColumns: 94, adminOnly: false },
      { key: "price", orderColumns: 95, adminOnly: false },
    ],
  },
  balloons: {
    displayFacets: [
      { key: "balloons-diameter-mm", orderFacets: 13, adminOnly: false },
      { key: "balloons-working-length", orderFacets: 14, adminOnly: false },
      { key: "proximal-neck-id-in", orderFacets: 15, adminOnly: false },
      { key: "distal-neck-id-in", orderFacets: 16, adminOnly: false },
      { key: "material", orderFacets: 17, adminOnly: false, isOpen: true },
      { key: "material-grade", orderFacets: 18, adminOnly: false },
      { key: "durometer", orderFacets: 19, adminOnly: false },
      { key: "shape", orderFacets: 20, adminOnly: false },
    ],
    displayHits: [
      { key: "type", orderColumns: 12, adminOnly: false },
      { key: "material", orderColumns: 13, adminOnly: false },
      { key: "balloons-diameter-mm", orderColumns: 14, adminOnly: false },
      { key: "balloons-working-length", orderColumns: 15, adminOnly: false },
      { key: "shape", orderColumns: 16, adminOnly: false },
    ],
    sorting: {
      key: "balloons-diameter-mm",
      orderby: facets["balloons-diameter-mm"].attribute,
      order: "asc",
    },
  },
  "balloons-and-catheters": {
    displayFacets: [
      { key: "balloons-diameter-mm", orderFacets: 13, adminOnly: false },
      { key: "balloons-working-length", orderFacets: 14, adminOnly: false },
      { key: "material", orderFacets: 15, adminOnly: false },
      { key: "shape", orderFacets: 16, adminOnly: false },
      { key: "type", orderFacets: 17, adminOnly: false },
    ],
    displayHits: [
      { key: "material", orderColumns: 13, adminOnly: false },
      { key: "balloons-diameter-mm", orderColumns: 14, adminOnly: false },
      { key: "balloons-working-length", orderColumns: 15, adminOnly: false },
      { key: "type", orderColumns: 16, adminOnly: false },
      { key: "shape", orderColumns: 17, adminOnly: false },
    ],
  },
  batteries: {
    displayFacets: [
      { key: "type", orderFacets: 13, adminOnly: false },
      { key: "case-material", orderFacets: 14, adminOnly: false },
    ],
    displayHits: [
      { key: "type", orderColumns: 13, adminOnly: false },
      { key: "description", orderColumns: 15, adminOnly: false },
    ],
  },
  braid: {
    displayFacets: [
      { key: "tubing-id-in", orderFacets: 13, adminOnly: false, precision: { imperial: 4, metric: 2 } },
      { key: "length-in", orderFacets: 14, adminOnly: false, precision: { imperial: 4, metric: 2 } },
      { key: "material", orderFacets: 15, adminOnly: false },
      { key: "wire-size", orderFacets: 16, adminOnly: false },
      { key: "ppi", orderFacets: 17, adminOnly: false },
    ],
    displayHits: [
      { key: "type", orderColumns: 10, adminOnly: false },
      { key: "tubing-id-in", orderColumns: 11, adminOnly: false, precision: { imperial: 4, metric: 2 } },
      { key: "ppi", orderColumns: 12, adminOnly: false },
      { key: "length-in", orderColumns: 13, adminOnly: false, precision: { imperial: 4, metric: 2 } },
      { key: "wire-size", orderColumns: 14, adminOnly: false },
    ],
    sorting: {
      key: "length-in",
      orderby: facets["length-in"].attribute,
      order: "asc",
    },
  },
  "braid-wire": {
    displayFacets: [
      { key: "material", orderFacets: 13, adminOnly: false },
      { key: "size", orderFacets: 14, adminOnly: false, isOpen: true },
      { key: "type", orderFacets: 15, adminOnly: false, isOpen: true },
    ],
    displayHits: [
      { key: "material", orderColumns: 13, adminOnly: false },
      { key: "size", orderColumns: 14, adminOnly: false },
      { key: "tensile-tange-ksi", orderColumns: 15, adminOnly: false },
      { key: "type", orderColumns: 16, adminOnly: false },
      { key: "length-ft", orderColumns: 17, adminOnly: false, precision: 0 },
    ],
    sorting: { key: "size", orderby: facets["size"].attribute, order: "asc" },
  },
  "cases-trays": {
    displayFacets: [
      { key: "type", orderFacets: 13, adminOnly: false, isOpen: true },
    ],
    displayHits: [
      { key: "type", orderColumns: 13, adminOnly: false },
      { key: "description", orderColumns: 14, adminOnly: false },
    ],
    sorting: { key: "type", orderby: facets["type"].attribute, order: "asc" },
  },
  catheters: {
    displayFacets: [
      { key: "material", orderFacets: 13, adminOnly: false },
      { key: "type", orderFacets: 14, adminOnly: false, isOpen: true },
    ],
    displayHits: [
      { key: "type", orderColumns: 13, adminOnly: false },
      { key: "description", orderColumns: 14, adminOnly: false },
    ],
    sorting: { key: "type", orderby: facets["type"].attribute, order: "asc" },
  },
  "catheter-handles": {
    displayFacets: [
      { key: "type", orderFacets: 13, adminOnly: false, isOpen: true },
      { key: "compatible-shaft-fr", orderFacets: 14, adminOnly: false },
      { key: "shaft-hub-id-in", orderFacets: 15, adminOnly: false },
      { key: "handle-length-in", orderFacets: 16, adminOnly: false },
    ],
    displayHits: [
      { key: "type", orderColumns: 13, adminOnly: false },
      { key: "compatible-shaft-fr", orderColumns: 14, adminOnly: false },
      { key: "shaft-hub-id-in", orderColumns: 15, adminOnly: false },
    ],
    sorting: {
      key: "external-tube-od-fr",
      orderby: facets["external-tube-od-fr"].attribute,
      order: "asc",
    },
  },
  coatings: {
    displayFacets: [
      { key: "type", orderFacets: 13, adminOnly: false, isOpen: true },
    ],
    displayHits: [
      { key: "type", orderColumns: 13, adminOnly: false },
      { key: "description", orderColumns: 14, adminOnly: false },
    ],
    sorting: { key: "type", orderby: facets["type"].attribute, order: "asc" },
  },
  "coils-springs": {
    displayFacets: [
      { key: "type", orderFacets: 13, adminOnly: false, isOpen: true },
      {
        key: "tubing-od-in",
        orderFacets: 14,
        adminOnly: false,
        precision: { imperial: 4, metric: 2 },
      },
      {
        key: "tubing-id-in",
        orderFacets: 15,
        adminOnly: false,
        precision: { imperial: 4, metric: 2 },
      },
      {
        key: "length-in",
        orderFacets: 16,
        adminOnly: false,
        precision: { imperial: 4, metric: 2 },
      },
      { key: "material", orderFacets: 17, adminOnly: false },
    ],
    displayHits: [
      { key: "material", orderColumns: 13, adminOnly: false },
      {
        key: "tubing-od-in",
        orderColumns: 14,
        adminOnly: false,
        precision: { imperial: 4, metric: 2 },
      },
      {
        key: "tubing-id-in",
        orderColumns: 15,
        adminOnly: false,
        precision: { imperial: 4, metric: 2 },
      },
      {
        key: "length-in",
        orderColumns: 16,
        adminOnly: false,
        precision: { imperial: 4, metric: 2 },
      },
      { key: "type", orderColumns: 17, adminOnly: false },
    ],
    sorting: { key: "type", orderby: facets["type"].attribute, order: "asc" },
  },
  "composite-tubing": {
    displayFacets: [
      {
        key: "tubing-id-in",
        orderFacets: 13,
        adminOnly: false,
        precision: { imperial: 4, metric: 2 },
      },
      {
        key: "tubing-od-in",
        orderFacets: 14,
        adminOnly: false,
        precision: { imperial: 4, metric: 2 },
      },
      {
        key: "wall-thickness-in",
        orderFacets: 15,
        adminOnly: false,
        precision: { imperial: 4, metric: 2 },
      },
      { key: "length-in", orderFacets: 16, adminOnly: false, precision: 0 },
      { key: "material", orderFacets: 17, adminOnly: false },
      { key: "type", orderFacets: 18, adminOnly: false, isOpen: true },
    ],
    displayHits: [
      { key: "material", orderColumns: 13, adminOnly: false },
      {
        key: "tubing-id-in",
        orderColumns: 14,
        adminOnly: false,
        precision: { imperial: 4, metric: 2 },
      },
      {
        key: "tubing-od-in",
        orderColumns: 15,
        adminOnly: false,
        precision: { imperial: 4, metric: 2 },
      },
      { key: "length-in", orderColumns: 16, adminOnly: false, precision: 0 },
      {
        key: "wall-thickness-in",
        orderColumns: 17,
        adminOnly: false,
        precision: { imperial: 4, metric: 2 },
      },
      { key: "type", orderColumns: 18, adminOnly: false },
    ],
    sorting: {
      key: "tubing-id-in",
      orderby: facets["tubing-id-in"].attribute,
      order: "asc",
    },
  },
  "connectors-fittings": {
    displayFacets: [
      {
        key: "type",
        orderFacets: 13,
        adminOnly: false,
        isOpen: true,
      },
      { key: "material", orderFacets: 14, adminOnly: false },
      { key: "color", orderFacets: 15, adminOnly: false },
    ],
    displayHits: [
      { key: "type", orderColumns: 13, adminOnly: false },
      { key: "material", orderColumns: 14, adminOnly: false },
      { key: "description", orderColumns: 15, adminOnly: false },
    ],
    sorting: { key: "type", orderby: facets["type"].attribute, order: "asc" },
  },
  "dilators-introducers-sheaths": {
    displayFacets: [
      { key: "type", orderFacets: 13, adminOnly: false, isOpen: true },
      {
        key: "tubing-od-in",
        orderFacets: 14,
        adminOnly: false,
        precision: { imperial: 3, metric: 1 },
      },
      { key: "french-size", orderFacets: 15, adminOnly: false, precision: 1 },
      {
        key: "length-in",
        orderFacets: 16,
        adminOnly: false,
        precision: { imperial: 3, metric: 1 },
      },
    ],
    displayHits: [
      { key: "type", orderColumns: 13, adminOnly: false },
      { key: "french-size", orderColumns: 14, adminOnly: false, precision: 1 },
      { key: "description", orderColumns: 15, adminOnly: false },
    ],
    sorting: { key: "type", orderby: facets["type"].attribute, order: "asc" },
  },
  electrodes: {
    displayFacets: [
      { key: "type", orderFacets: 13, adminOnly: false },
      { key: "material", orderFacets: 14, adminOnly: false, isOpen: true },
    ],
    displayHits: [
      { key: "type", orderColumns: 13, adminOnly: false },
      { key: "material", orderColumns: 14, adminOnly: false },
      { key: "description", orderColumns: 15, adminOnly: false },
    ],
    sorting: { key: "type", orderby: facets["type"].attribute, order: "asc" },
  },
  "equipment-fixtures-tools": {
    displayFacets: [
      { key: "type", orderFacets: 13, adminOnly: false, isOpen: true },
    ],
    displayHits: [
      { key: "type", orderColumns: 13, adminOnly: false },
      { key: "description", orderColumns: 14, adminOnly: false },
    ],
    sorting: { key: "type", orderby: facets["type"].attribute, order: "asc" },
  },
  "filters-valves": {
    displayFacets: [
      { key: "type", orderFacets: 13, adminOnly: false, isOpen: true },
    ],
    displayHits: [
      { key: "type", orderColumns: 13, adminOnly: false },
      { key: "description", orderColumns: 14, adminOnly: false },
    ],
    sorting: { key: "type", orderby: facets["type"].attribute, order: "asc" },
  },
  gears: {
    displayFacets: [
      { key: "material", orderFacets: 13, adminOnly: false },
      {
        key: "number-of-teeth",
        orderFacets: 14,
        adminOnly: false,
        isOpen: true,
      },
      { key: "thickness-in", orderFacets: 15, adminOnly: false },
      {
        key: "pitch-diameter-in",
        orderFacets: 16,
        adminOnly: false,
        isOpen: true,
      },
    ],
    displayHits: [
      { key: "material", orderColumns: 13, adminOnly: false },
      { key: "number-of-teeth", orderColumns: 14, adminOnly: false },
      { key: "thickness-in", orderColumns: 15, adminOnly: false },
    ],
    sorting: {
      key: "thickness-in",
      orderby: facets["thickness-in"].attribute,
      order: "asc",
    },
  },
  guidewires: {
    displayFacets: [
      { key: "tubing-od-in", orderFacets: 13, adminOnly: false },
      { key: "material", orderFacets: 14, adminOnly: false },
      { key: "length-in", orderFacets: 15, adminOnly: false },
      { key: "type", orderFacets: 16, adminOnly: false, isOpen: true },
    ],
    displayHits: [
      { key: "material", orderColumns: 13, adminOnly: false },
      { key: "tubing-od-in", orderColumns: 14, adminOnly: false },
      { key: "length-in", orderColumns: 15, adminOnly: false },
      { key: "type", orderColumns: 16, adminOnly: false },
    ],
    sorting: { key: "type", orderby: facets["type"].attribute, order: "asc" },
  },
  "guidewires-accessories": {
    displayFacets: [
      { key: "type", orderFacets: 13, adminOnly: false, isOpen: true },
      { key: "material", orderFacets: 14, adminOnly: false },
    ],
    displayHits: [
      { key: "type", orderColumns: 13, adminOnly: false },
      { key: "description", orderColumns: 14, adminOnly: false },
    ],
    sorting: { key: "type", orderby: facets["type"].attribute, order: "asc" },
  },
  "heat-shrink-tubing": {
    displayFacets: [
      { key: "min-exp-id-in", orderFacets: 13, adminOnly: false },
      { key: "max-recovered-id-in", orderFacets: 14, adminOnly: false },
      { key: "hst-shrink-ratio", orderFacets: 15, adminOnly: false },
      { key: "material", orderFacets: 16, adminOnly: false, isOpen: true },
      { key: "durometer", orderFacets: 17, adminOnly: false },
    ],
    displayHits: [
      { key: "material", orderColumns: 13, adminOnly: false },
      { key: "min-exp-id-in", orderColumns: 14, adminOnly: false },
      {
        key: "length-in",
        orderColumns: 15,
        adminOnly: false,
        precision: { imperial: 3, metric: 1 },
      },
      { key: "hst-shrink-ratio", orderColumns: 16, adminOnly: false },
    ],
    sorting: {
      key: "min-exp-id-in",
      orderby: facets["min-exp-id-in"].attribute,
      order: "asc",
    },
  },
  "laser-cut-hypotubes": {
    displayFacets: [
      { key: "material", orderFacets: 13, adminOnly: false },
      { key: "tubing-id-in", orderFacets: 14, adminOnly: false },
      { key: "tubing-od-in", orderFacets: 15, adminOnly: false },
      { key: "wall-thickness-in", orderFacets: 16, adminOnly: false },
      { key: "gauge-size", orderFacets: 17, adminOnly: false },
      { key: "pitch-in", orderFacets: 18, adminOnly: false },
      { key: "cpr", orderFacets: 19, adminOnly: false },
    ],
    displayHits: [
      { key: "material", orderColumns: 13, adminOnly: false },
      { key: "tubing-id-in", orderColumns: 14, adminOnly: false },
      { key: "tubing-od-in", orderColumns: 15, adminOnly: false },
      { key: "wall-thickness-in", orderColumns: 16, adminOnly: false },
      { key: "pitch-in", orderColumns: 17, adminOnly: false },
      { key: "cpr", orderColumns: 18, adminOnly: false },
    ],
    sorting: {
      key: "tubing-id-in",
      orderby: facets["tubing-id-in"].attribute,
      order: "asc",
    },
  },
  mandrels: {
    displayFacets: [
      {
        key: "tubing-od-in",
        orderFacets: 13,
        adminOnly: false,
        precision: { imperial: 4, metric: 2 },
      },
      { key: "type", orderFacets: 14, adminOnly: false, isOpen: true },
      { key: "material", orderFacets: 15, adminOnly: false },
      {
        key: "length-in",
        orderFacets: 16,
        adminOnly: false,
        precision: { imperial: 2, metric: 0 },
      },
    ],
    displayHits: [
      { key: "material", orderColumns: 15, adminOnly: false },
      { key: "french-size", orderColumns: 15, adminOnly: false, precision: 4 },
      {
        key: "tubing-od-in",
        orderColumns: 13,
        adminOnly: false,
        precision: { imperial: 4, metric: 2 },
      },
      {
        key: "length-in",
        orderColumns: 16,
        adminOnly: false,
        precision: { imperial: 2, metric: 0 },
      },
      { key: "type", orderColumns: 14, adminOnly: false },
    ],
    sorting: {
      key: "tubing-od-in",
      orderby: facets["tubing-od-in"].attribute,
      order: "asc",
    },
  },
  "marker-bands": {
    displayFacets: [
      {
        key: "tubing-id-in",
        orderFacets: 13,
        adminOnly: false,
        precision: { imperial: 5, metric: 3 },
      },
      {
        key: "tubing-od-in",
        orderFacets: 14,
        adminOnly: false,
        precision: { imperial: 4, metric: 2 },
      },
      {
        key: "wall-thickness-in",
        orderFacets: 15,
        adminOnly: false,
        precision: { imperial: 5, metric: 3 },
      },
      {
        key: "length-in",
        orderFacets: 16,
        adminOnly: false,
        precision: { imperial: 4, metric: 2 },
      },
      { key: "material", orderFacets: 17, adminOnly: false },
    ],
    displayHits: [
      { key: "material", orderColumns: 13, adminOnly: false },
      {
        key: "tubing-id-in",
        orderColumns: 14,
        adminOnly: false,
        precision: { imperial: 5, metric: 3 },
      },
      {
        key: "tubing-od-in",
        orderColumns: 15,
        adminOnly: false,
        precision: { imperial: 4, metric: 2 },
      },
      {
        key: "length-in",
        orderColumns: 16,
        adminOnly: false,
        precision: { imperial: 4, metric: 2 },
      },
      {
        key: "wall-thickness-in",
        orderColumns: 17,
        adminOnly: false,
        precision: { imperial: 5, metric: 3 },
      },
    ],
    sorting: {
      key: "tubing-id-in",
      orderby: facets["tubing-id-in"].attribute,
      order: "asc",
    },
  },
  membranes: {
    displayFacets: [
      { key: "material", orderFacets: 13, adminOnly: false },
      { key: "type", orderFacets: 14, adminOnly: false, isOpen: true },
      { key: "size", orderFacets: 15, adminOnly: false },
    ],
    displayHits: [
      { key: "material", orderColumns: 13, adminOnly: false },
      { key: "description", orderColumns: 14, adminOnly: false },
    ],
    sorting: {
      key: "material",
      orderby: facets["material"].attribute,
      order: "asc",
    },
  },
  "metal-tubing": {
    displayFacets: [
      {
        key: "tubing-id-in",
        orderFacets: 13,
        adminOnly: false,
        precision: { imperial: 5, metric: 3 },
      },
      {
        key: "tubing-od-in",
        orderFacets: 14,
        adminOnly: false,
        precision: { imperial: 4, metric: 2 },
      },
      {
        key: "wall-thickness-in",
        orderFacets: 15,
        adminOnly: false,
        precision: { imperial: 5, metric: 3 },
      },
      {
        key: "length-in",
        orderFacets: 16,
        adminOnly: false,
        precision: { imperial: 4, metric: 2 },
      },
      { key: "material", orderFacets: 17, adminOnly: false },
      { key: "type", orderFacets: 18, adminOnly: false, isOpen: true },
    ],
    displayHits: [
      { key: "material", orderColumns: 13, adminOnly: false },
      {
        key: "tubing-id-in",
        orderColumns: 14,
        adminOnly: false,
        precision: { imperial: 5, metric: 3 },
      },
      {
        key: "tubing-od-in",
        orderColumns: 15,
        adminOnly: false,
        precision: { imperial: 4, metric: 2 },
      },
      {
        key: "length-in",
        orderColumns: 16,
        adminOnly: false,
        precision: { imperial: 4, metric: 2 },
      },
      {
        key: "wall-thickness-in",
        orderColumns: 17,
        adminOnly: false,
        precision: { imperial: 5, metric: 3 },
      },
      { key: "type", orderColumns: 18, adminOnly: false },
    ],
    sorting: {
      key: "tubing-id-in",
      orderby: facets["tubing-id-in"].attribute,
      order: "asc",
    },
  },
  "metal-pins": {
    displayFacets: [
      { key: "material", orderFacets: 13, adminOnly: false, isOpen: true },
      {
        key: "tubing-od-in",
        orderFacets: 14,
        adminOnly: false,
        precision: { imperial: 4, metric: 2 },
      },
      {
        key: "length-in",
        orderFacets: 15,
        adminOnly: false,
        precision: { imperial: 4, metric: 2 },
      },
      { key: "surface-finish", orderFacets: 16, adminOnly: false },
    ],
    displayHits: [
      { key: "material", orderColumns: 13, adminOnly: false },
      {
        key: "tubing-od-in",
        orderColumns: 14,
        adminOnly: false,
        precision: { imperial: 4, metric: 2 },
      },
      {
        key: "length-in",
        orderColumns: 15,
        adminOnly: false,
        precision: { imperial: 4, metric: 2 },
      },
      { key: "surface-finish", orderColumns: 16, adminOnly: false },
    ],
    sorting: {
      key: "tubing-od-in",
      orderby: facets["tubing-od-in"].attribute,
      order: "asc",
    },
  },
  sharps: {
    displayFacets: [
      { key: "material", orderFacets: 13, adminOnly: false },
      { key: "type", orderFacets: 14, adminOnly: false },
    ],
    displayHits: [
      { key: "type", orderColumns: 13, adminOnly: false },
      { key: "description", orderColumns: 14, adminOnly: false },
    ],
  },
  needles: {
    displayFacets: [
      { key: "material", orderFacets: 13, adminOnly: false },
      { key: "sharps-type", orderFacets: 14, adminOnly: false },
      { key: "point-type", orderFacets: 15, adminOnly: false, isOpen: true },
    ],
    displayHits: [
      { key: "type", orderColumns: 13, adminOnly: false },
      { key: "description", orderColumns: 14, adminOnly: false },
    ],
    sorting: { key: "type", orderby: facets["type"].attribute, order: "asc" },
  },
  "needles-scalpels": {
    displayFacets: [
      { key: "type", orderFacets: 13, adminOnly: false, isOpen: true },
    ],
    displayHits: [
      { key: "type", orderColumns: 13, adminOnly: false },
      { key: "description", orderColumns: 14, adminOnly: false },
    ],
    sorting: { key: "type", orderby: facets["type"].attribute, order: "asc" },
  },
  "nitinol-parts": {
    displayFacets: [
      { key: "id-mm", orderFacets: 13, adminOnly: false },
      { key: "length-mm", orderFacets: 14, adminOnly: false },
      { key: "material", orderFacets: 15, adminOnly: false },
      { key: "covering", orderFacets: 16, adminOnly: false },
    ],
    displayHits: [
      { key: "material", orderColumns: 13, adminOnly: false },
      { key: "id-mm", orderColumns: 14, adminOnly: false },
      { key: "length-mm", orderColumns: 15, adminOnly: false },
      { key: "covering", orderColumns: 16, adminOnly: false },
    ],
    sorting: { key: "id-mm", orderby: facets["id-mm"].attribute, order: "asc" },
  },
  "nitinol-sheets": {
    displayFacets: [
      {
        key: "length-in",
        orderFacets: 13,
        adminOnly: false,
        precision: { imperial: 3, metric: 1 },
      },
      { key: "width-in", orderFacets: 14, adminOnly: false },
      { key: "thickness-in", orderFacets: 15, adminOnly: false },
      { key: "material", orderFacets: 16, adminOnly: false, isOpen: true },
    ],
    displayHits: [
      { key: "material", orderColumns: 13, adminOnly: false },
      { key: "thickness-in", orderColumns: 14, adminOnly: false },
      { key: "width-in", orderColumns: 15, adminOnly: false },
    ],
    sorting: {
      key: "width-in",
      orderby: facets["width-in"].attribute,
      order: "asc",
    },
  },
  packaging: {
    displayFacets: [
      { key: "type", orderFacets: 13, adminOnly: false, isOpen: true },
      { key: "material", orderFacets: 14, adminOnly: false },
    ],
    displayHits: [
      { key: "type", orderColumns: 13, adminOnly: false },
      { key: "material", orderColumns: 14, adminOnly: false },
      { key: "description", orderColumns: 15, adminOnly: false },
    ],
    sorting: { key: "type", orderby: facets["type"].attribute, order: "asc" },
  },
  "pull-wire-assemblies": {
    displayFacets: [
      {
        key: "pull-ring-material",
        orderFacets: 13,
        adminOnly: false,
        isOpen: true,
      },
      { key: "pull-ring-od-in", orderFacets: 14, adminOnly: false },
      { key: "pull-ring-id-in", orderFacets: 15, adminOnly: false },
      { key: "pull-ring-wires", orderFacets: 16, adminOnly: false },
      { key: "pull-ring-wire-material", orderFacets: 17, adminOnly: false },
      { key: "pull-ring-wire-od-in", orderFacets: 18, adminOnly: false },
      { key: "pull-ring-wire-length-in", orderFacets: 19, adminOnly: false },
    ],
    displayHits: [
      { key: "pull-ring-material", orderColumns: 13, adminOnly: false },
      { key: "pull-ring-od-in", orderColumns: 14, adminOnly: false },
      { key: "pull-ring-wires", orderColumns: 15, adminOnly: false },
      { key: "pull-ring-wire-od-in", orderColumns: 16, adminOnly: false },
      { key: "pull-ring-wire-length-in", orderColumns: 17, adminOnly: false },
    ],
    sorting: {
      key: "pull-ring-od-in",
      orderby: facets["pull-ring-od-in"].attribute,
      order: "asc",
    },
  },
  "polymer-tubing": {
    displayFacets: [
      {
        key: "tubing-id-in",
        orderFacets: 13,
        adminOnly: false,
        precision: { imperial: 4, metric: 2 },
      },
      {
        key: "tubing-od-in",
        orderFacets: 14,
        adminOnly: false,
        precision: { imperial: 4, metric: 2 },
      },
      {
        key: "wall-thickness-in",
        orderFacets: 15,
        adminOnly: false,
        precision: { imperial: 5, metric: 3 },
      },
      {
        key: "length-in",
        orderFacets: 16,
        adminOnly: false,
        precision: { imperial: 2, metric: 1 },
      },
      { key: "material", orderFacets: 17, adminOnly: false },
      { key: "material-grade", orderFacets: 18, adminOnly: false },
      { key: "durometer", orderFacets: 19, adminOnly: false },
      { key: "type", orderFacets: 97, adminOnly: false, isOpen: true },
    ],
    displayHits: [
      { key: "material", orderColumns: 13, adminOnly: false },
      {
        key: "tubing-id-in",
        orderColumns: 14,
        adminOnly: false,
        precision: { imperial: 4, metric: 2 },
      },
      {
        key: "tubing-od-in",
        orderColumns: 15,
        adminOnly: false,
        precision: { imperial: 4, metric: 2 },
      },
      {
        key: "length-in",
        orderColumns: 16,
        adminOnly: false,
        precision: { imperial: 2, metric: 1 },
      },
      {
        key: "wall-thickness-in",
        orderColumns: 17,
        adminOnly: false,
        precision: { imperial: 5, metric: 3 },
      },
      { key: "type", orderColumns: 18, adminOnly: false },
    ],
    sorting: {
      key: "tubing-id-in",
      orderby: facets["tubing-id-in"].attribute,
      order: "asc",
    },
  },
  "raw-materials": {
    displayFacets: [
      { key: "type", orderFacets: 13, adminOnly: false, isOpen: true },
      { key: "material", orderFacets: 14, adminOnly: false },
      { key: "color", orderFacets: 15, adminOnly: false },
    ],
    displayHits: [
      { key: "type", orderColumns: 13, adminOnly: false },
      { key: "material", orderColumns: 14, adminOnly: false },
      { key: "description", orderColumns: 15, adminOnly: false },
    ],
    sorting: { key: "type", orderby: facets["type"].attribute, order: "asc" },
  },
  sensors: {
    displayFacets: [
      { key: "type", orderFacets: 13, adminOnly: false, isOpen: true },
    ],
    displayHits: [
      { key: "type", orderColumns: 13, adminOnly: false },
      { key: "description", orderColumns: 14, adminOnly: false },
    ],
    sorting: { key: "type", orderby: facets["type"].attribute, order: "asc" },
  },
  sutures: {
    displayFacets: [
      { key: "material", orderFacets: 13, adminOnly: false },
      { key: "color", orderFacets: 14, adminOnly: false, isOpen: true },
      { key: "type", orderFacets: 15, adminOnly: false },
    ],
    displayHits: [
      { key: "type", orderColumns: 13, adminOnly: false },
      { key: "description", orderColumns: 14, adminOnly: false },
    ],
    sorting: { key: "type", orderby: facets["type"].attribute, order: "asc" },
  },
  syringes: {
    displayFacets: [
      { key: "volume", orderFacets: 13, adminOnly: false },
      { key: "type", orderFacets: 14, adminOnly: false, isOpen: true },
    ],
    displayHits: [
      { key: "volume", orderColumns: 13, adminOnly: false },
      { key: "description", orderColumns: 14, adminOnly: false },
    ],
    sorting: {
      key: "volume",
      orderby: facets["volume"].attribute,
      order: "asc",
    },
  },
  textiles: {
    displayFacets: [
      { key: "material", orderFacets: 13, adminOnly: false },
      { key: "color", orderFacets: 14, adminOnly: false },
      { key: "type", orderFacets: 15, adminOnly: false },
    ],
    displayHits: [
      { key: "type", orderColumns: 13, adminOnly: false },
      { key: "description", orderColumns: 14, adminOnly: false },
    ],
    sorting: { key: "type", orderby: facets["type"].attribute, order: "asc" },
  },
  "thin-films": {
    displayFacets: [
      { key: "width-in", orderFacets: 13, adminOnly: false },
      { key: "thickness-in", orderFacets: 14, adminOnly: false },
      { key: "material", orderFacets: 15, adminOnly: false, isOpen: true },
      { key: "durometer", orderFacets: 16, adminOnly: false },
    ],
    displayHits: [
      { key: "material", orderColumns: 13, adminOnly: false },
      { key: "thickness-in", orderColumns: 14, adminOnly: false },
      { key: "width-in", orderColumns: 15, adminOnly: false },
    ],
    sorting: {
      key: "thickness-in",
      orderby: facets["thickness-in"].attribute,
      order: "asc",
    },
  },
  tools: {
    displayFacets: [
      { key: "type", orderFacets: 13, adminOnly: false, isOpen: true },
    ],
    displayHits: [
      { key: "type", orderColumns: 13, adminOnly: false },
      { key: "description", orderColumns: 14, adminOnly: false },
    ],
    sorting: { key: "type", orderby: facets["type"].attribute, order: "asc" },
  },
  vents: {
    displayFacets: [
      { key: "type", orderFacets: 13, adminOnly: false, isOpen: true },
      { key: "vent-rating", orderFacets: 14, adminOnly: false, isOpen: true },
    ],
    displayHits: [
      { key: "type", orderColumns: 13, adminOnly: false },
      { key: "description", orderColumns: 14, adminOnly: false },
    ],
    sorting: { key: "type", orderby: facets["type"].attribute, order: "asc" },
  },
  washers: {
    displayFacets: [
      { key: "material", orderFacets: 13, adminOnly: false },
      { key: "tubing-id-in", orderFacets: 14, adminOnly: false },
      { key: "tubing-od-in", orderFacets: 15, adminOnly: false },
      { key: "thickness-in", orderFacets: 16, adminOnly: false },
      { key: "condition", orderFacets: 17, adminOnly: false, isOpen: true },
    ],
    displayHits: [
      { key: "material", orderColumns: 13, adminOnly: false },
      { key: "tubing-id-in", orderColumns: 14, adminOnly: false },
      { key: "tubing-od-in", orderColumns: 15, adminOnly: false },
      { key: "thickness-in", orderColumns: 16, adminOnly: false },
    ],
    sorting: {
      key: "tubing-id-in",
      orderby: facets["tubing-id-in"].attribute,
      order: "asc",
    },
  },
  wire: {
    displayFacets: [
      {
        key: "tubing-od-in",
        orderFacets: 13,
        adminOnly: false,
        precision: { imperial: 4, metric: 2 },
      },
      { key: "awg", orderFacets: 14, adminOnly: false },
      { key: "construction", orderFacets: 15, adminOnly: false, isOpen: true },
      { key: "type", orderFacets: 16, adminOnly: false },
      { key: "material", orderFacets: 17, adminOnly: false },
      { key: "material-grade", orderFacets: 18, adminOnly: false },
      {
        key: "length-ft",
        orderFacets: 19,
        adminOnly: false,
        precision: { imperial: 4, metric: 2 },
      },
    ],
    displayHits: [
      { key: "material", orderColumns: 13, adminOnly: false },
      {
        key: "tubing-od-in",
        orderColumns: 14,
        adminOnly: false,
        precision: { imperial: 4, metric: 2 },
      },
      {
        key: "length-ft",
        orderColumns: 15,
        adminOnly: false,
        precision: { imperial: 4, metric: 2 },
      },
      { key: "type", orderColumns: 16, adminOnly: false },
      { key: "construction", orderColumns: 17, adminOnly: false },
    ],
    sorting: {
      key: "tubing-od-in",
      orderby: facets["tubing-od-in"].attribute,
      order: "asc",
    },
  },
  "hypodermic-tubing": {
    displayFacets: [
      { key: "material", orderFacets: 13, adminOnly: false },
      { key: "gauge", orderFacets: 14, adminOnly: false },
      { key: "gauge-wall", orderFacets: 15, adminOnly: false },
      {
        key: "tubing-id-in",
        orderFacets: 16,
        adminOnly: false,
        precision: { imperial: 4, metric: 2 },
      },
      {
        key: "tubing-od-in",
        orderFacets: 17,
        adminOnly: false,
        precision: { imperial: 4, metric: 2 },
      },
      {
        key: "wall-thickness-in",
        orderFacets: 18,
        adminOnly: false,
        precision: { imperial: 4, metric: 2 },
      },
      {
        key: "length-in",
        orderFacets: 19,
        adminOnly: false,
        precision: { imperial: 3, metric: 1 },
      },
    ],
    displayHits: [
      { key: "material", orderColumns: 13, adminOnly: false },
      {
        key: "tubing-id-in",
        orderColumns: 14,
        adminOnly: false,
        precision: { imperial: 4, metric: 2 },
      },
      {
        key: "tubing-od-in",
        orderColumns: 15,
        adminOnly: false,
        precision: { imperial: 4, metric: 2 },
      },
      {
        key: "length-in",
        orderColumns: 16,
        adminOnly: false,
        precision: { imperial: 3, metric: 1 },
      },
      { key: "gauge", orderColumns: 17, adminOnly: false },
      { key: "gauge-wall", orderColumns: 18, adminOnly: false },
    ],
    sorting: {
      key: "tubing-id-in",
      orderby: facets["tubing-id-in"].attribute,
      order: "asc",
    },
  },
  "o-rings-seals": {
    displayFacets: [
      { key: "type", orderFacets: 14, adminOnly: false, isOpen: true },
      { key: "fda-compliant", orderFacets: 15, adminOnly: false },
      { key: "3a-compliant", orderFacets: 16, adminOnly: false },
      { key: "usp-class-vi", orderFacets: 17, adminOnly: false },
      { key: "reach-rohs-compliant", orderFacets: 18, adminOnly: false },
      { key: "metal-detectable", orderFacets: 19, adminOnly: false },
      { key: "cleanroom", orderFacets: 20, adminOnly: false },
      {
        key: "tubing-id-in",
        orderFacets: 21,
        adminOnly: false,
        precision: { imperial: 3, metric: 1 },
      },
      {
        key: "tubing-od-in",
        orderFacets: 22,
        adminOnly: false,
        precision: { imperial: 3, metric: 1 },
      },
      { key: "material", orderFacets: 23, adminOnly: false, isOpen: true },
      { key: "durometer", orderFacets: 24, adminOnly: false },
      { key: "color", orderFacets: 25, adminOnly: false },
    ],
    displayHits: [
      { key: "type", orderColumns: 13, adminOnly: false },
      { key: "dash-number", orderColumns: 14, adminOnly: false },
      {
        key: "tubing-id-in",
        orderColumns: 15,
        adminOnly: false,
        precision: { imperial: 3, metric: 1 },
      },
      {
        key: "tubing-od-in",
        orderColumns: 16,
        adminOnly: false,
        precision: { imperial: 3, metric: 1 },
      },
      { key: "material", orderColumns: 17, adminOnly: false },
    ],
    sorting: {
      key: "tubing-id-in",
      orderby: facets["tubing-id-in"].attribute,
      order: "asc",
    },
  },
  "rd-lab-kits": {
    displayFacets: [
      { key: "type", orderFacets: 13, adminOnly: false, isOpen: true },
      { key: "material", orderFacets: 14, adminOnly: false },
    ],
    displayHits: [
      { key: "type", orderColumns: 13, adminOnly: false },
      { key: "description", orderColumns: 14, adminOnly: false },
    ],
    sorting: { key: "type", orderby: facets["type"].attribute, order: "asc" },
  },
};
